import React from 'react'
import { useParams } from 'react-router-dom'
import './underlineStyle.css'

const DesktopNavbar = () => {

  const showDropdown = (e, id) => {
    e.preventDefault();
    document.getElementById(id).classList.remove("hidden");
  }

  const hideDropdown = (e, id) => {
    e.preventDefault();
    document.getElementById(id).classList.add("hidden")
  }

  let attendeeId = window.initialState && window.initialState.isAttendeeLoggedIn ? window.initialState.attendee.attendeeId : "attendeeId"

  return (
    <ul className='flex gap-[5rem]'>
      <li className='cursor-pointer text-purple hover:text-lightpurple'>
        <a href='https://reg.oneventseries.intel.com/flow/intel/innovation2022/attendee-portal/page/agenda' className='navBar-Agenda text-[1.8rem]'>
          My Agenda
        </a>
      </li>
      <li className='cursor-pointer text-purple hover:text-lightpurple'>
        <a href='https://reg.oneventseries.intel.com/flow/intel/innovation2022/attendee-portal/page/sessioncatalog' className='navBar-Catalog text-[1.8rem]'>
          Catalog
        </a>
      </li>
      <li className='cursor-pointer text-purple hover:text-lightpurple'>
        <a href={`https://intelinnovation.braindate.com/?utm_source=eventbase&utm_medium=integration&ext-id=${attendeeId}`} target="_blank" rel="noopener noreferrer" className='navBar-Braindate text-[1.8rem]'>
          Braindate
        </a>
      </li>
      <li className='cursor-pointer text-purple hover:text-lightpurple'>
        <a href='https://reg.oneventseries.intel.com/flow/intel/innovation2022/attendee-portal/page/surveys' className='navBar-Surveys text-[1.8rem]'>
          Surveys
        </a>
      </li>
    </ul>
  )
}

export default DesktopNavbar
